module.exports = __webpack_public_path__ + "img/img (55).d52855e5.jpg";